var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fshr-cardBadgeVue",class:[
    _vm.color && ("fshr-cardBadgeVue--color-" + _vm.color),
    _vm.size && ("fshr-cardBadgeVue--size-" + _vm.size),
    _vm.isAbsolute && "fshr-cardBadgeVue--isAbsolute",
    _vm.isBottom && "fshr-cardBadgeVue--isBottom" ]},[_c('span',{staticClass:"fshr-cardBadgeVue__label"},[_vm._v(_vm._s(_vm.label))]),(_vm.caption)?_c('span',{staticClass:"fshr-cardBadgeVue__caption"},[_vm._v(" "+_vm._s(_vm.caption)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }